<template>
  <div class="container">
    <div class="title">
      <span class="titleHeader">{{ ourAdvantageInfo.title[0] }}</span>
      <span class="titleFooter">{{ ourAdvantageInfo.title[1] }}</span>
    </div>
    <div class="subtitle">{{ ourAdvantageInfo.subtitle }}</div>
    <div class="listBox">
      <div class="listItem" v-for="(item,index) in ourAdvantageInfo.list" :key="index" :class="{'oddNumberItem': index % 2 !== 0 }">
        <img class="bgImage" :src="item.backImg" alt="">
        <div class="icon" :class="{'oddNumberIcon': index % 2 !== 0 }"></div>
        <div class="imageBox" :class="{'oddNumberImageBox': index % 2 !== 0 }">
          <img class="image" :src="item.img">
        </div>
        <div class="name" :class="{'oddNumberName': index % 2 !== 0 }">{{ item.name[0] }}</div>
        <div class="name" :class="{'oddNumberName': index % 2 !== 0 }">{{ item.name[1] }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OurAdvantage",
  props: {
    ourAdvantageInfo: {
      type: Object, defaults() {
        return {}
      }
    }
  },
  data() {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  background-color: #2A45A7;
  padding-top: 180px;
  .title {
    margin: 0 auto;
    font-size: 64px;
    font-family: "SourceHanSansSC-Bold-2";
    font-weight: bold;
    color: #EAFF74;
    .titleHeader {
      color: rgb(255,255,255);
    }
  }
  .subtitle {
    margin-top: 43px;
    font-size: 32px;
    font-family: "SourceHanSansSC-Bold-2";
    font-weight: bold;
    color: #FFFFFF;
  }
  .listBox {
    padding: 96px 120px 160px 120px;
    display: flex;
    justify-content: space-between;

    .listItem {
      width: 344px;
      padding-bottom: 54px;
      border-radius: 8px;
      box-sizing: border-box;
      position: relative;
      // background-image: url("~@/assets/homepage/ourAdvantage/bg_card_pink@2x.png");
      // background-position: 100% 100%;
      // background-size: 100% 100%;

      .bgImage {
        position: absolute;
        top: 0;
        left: 0;
        width: 344px;
        height: 100%;
        z-index: -1;
      }
      
      .icon {
        margin-top: 24px;
        margin-left: 24px;
        background-image: url("~@/assets/homepage/ourAdvantage/haoping-yuankuang@2x (1).png");
        background-position: 100% 100%;
        background-size: 100% 100%;
        width: 44px;
        height: 44px;
      }
      .oddNumberIcon {
        background-image: url("~@/assets/homepage/ourAdvantage/haoping-yuankuang@2x.png");
      }
      .imageBox {
        margin: 0 auto;
        width: 280px;
        border-bottom: 3px solid #FFFFFF;
        margin-bottom: 39px;
        .image {
          background-color: #E8EEFC;
          border-radius: 50%;
          margin: 0 auto;
          width: 280px;
          height: 280px;
          margin-bottom: 24px;
        }
      }
      .oddNumberImageBox {
        border-bottom: 3px solid #E43363;
      }
      .name {
        font-size: 24px;
        font-family: "SourceHanSansSC-Medium-2";
        font-weight: 500;
        color: #FFFFFF;
        margin-bottom: 5px;
        padding: 0 20px;
      }
      .oddNumberName {
        color: #E43363;
      }
    }
    // .oddNumberItem {
    //   background-image: url("~@/assets/homepage/ourAdvantage/bg_card_white@2x.png");
    // }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/homepage/childComps/OurAdvantage.vue